// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3fn4i","header__main":"header_header__main__1-xPf","header__main__logo":"header_header__main__logo__Xve05"};